<mat-dialog-content>
  <div class="tool-name-title">{{ tool }}</div>
  <div>Users: {{ names }}</div>
</mat-dialog-content>
<mat-dialog-actions>
  <button color="primary" mat-raised-button mat-dialog-close>Close</button>
</mat-dialog-actions>
